import { hotelCampaignRegistrationStatuses } from 'main/hotelStatuses'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getHealthCheckAutoInviteData } from '../../../actions/healthCheck'
import CustomHeader from '../../../components/ReusableComponents/HeaderTitles'
import LoadingIndicator from '../../../components/ReusableComponents/LoadingIndicator'
import Table from '../../../components/ReusableComponents/Table'
import Tab from '../../../components/ReusableComponents/Tabs'
import HealthCheckFilters from '../Common/Filters'
import useHealthCheckFilters from '../Common/useHealthCheckFilters'
import styles from './HealthCheckAutoInvite.module.scss'
import AutoInviteHealthRow from './Row'
import { getSortedResults } from './sortHelper'
import AutoInviteHealthTitleRow from './TitleRow'
import TotalRow from './TotalRow'

const HealthCheckAutoInvite = () => {
  const dispatch = useDispatch()

  const isLoading = useSelector(s => s.healthCheck.invites.isLoading)
  const hotelData = useSelector(s => s.healthCheck.invites.hotelData)
  const allhotelGroups = useSelector(s => s.healthCheck.invites.hotelGroups)
  const allhotelChains = useSelector(s => s.healthCheck.invites.hotelChains)

  const [filterState, filterDispatch] = useHealthCheckFilters('auto-invite')
  const [sortDecreasing, setSortDecreasing] = useState(false)
  const [sortByIndex, setSortByIndex] = useState(3)
  const [results, setResults] = useState([])

  const widths = filterState.showTelcoDetails
    ? [40, 264, 75, 75, 75, 75, 75, 75, 75, 75, 75, 75, 75]
    : [40, 350, 80, 80, 80, 80, 82, 60, 60, 60, 60, 60, 60, 60, 60, 60]

  useEffect(() => {
    dispatch(getHealthCheckAutoInviteData(filterState.periodStart, filterState.periodEnd))
  }, [dispatch, filterState.periodEnd, filterState.periodStart])

  useEffect(() => {
    function getFilteredResults(hotelData) {
      const {
        searchString,
        chains,
        brands,
        hotelGroups,
        subsidiaryStatus,
        csmIds,
        showLowOutreaches,
        showLowConversions
      } = filterState

      return hotelData
        .filter(h => h.searchKey.match(new RegExp(searchString, 'i')))
        .filter(h => (hotelGroups === 'all' ? true : h.groupName === hotelGroups))
        .filter(h => (chains === 'all' ? true : h.chainCode === chains))
        .filter(h => (brands === 'all' ? true : h.parentChainCode === brands))
        .filter(h => (showLowOutreaches === true ? h.bookings.periodCurrent === 0 : true))
        .filter(h =>
          showLowConversions === true ? h.conversions.periodCurrent === 0 : true
        )
        .filter(h => {
          if (subsidiaryStatus.length === 0) {
            return true
          } else if (hotelCampaignRegistrationStatuses.includes(h.subsidiaryStatus)) {
            return subsidiaryStatus.includes('PendingCampaignBrandRegistration')
          } else {
            return subsidiaryStatus.includes(h.subsidiaryStatus)
          }
        })
        .filter(h => {
          if (csmIds.length === 0) {
            return true
          } else {
            return csmIds.includes(`${h.csmUserId}`)
          }
        })
    }

    function getResults() {
      const results = getSortedResults(
        getFilteredResults(hotelData),
        filterState,
        sortByIndex,
        sortDecreasing
      )
      setResults(results)
    }

    getResults()
  }, [filterState, hotelData, sortByIndex, sortDecreasing])

  function handleTitleCellClick(rowIndex) {
    if (sortByIndex === rowIndex) {
      setSortDecreasing(d => !d)
    }
    setSortByIndex(rowIndex)
  }

  return (
    <div className={styles.wrapper}>
      <CustomHeader title="Hotel health check" width={1180} isFixed />
      <Tab.Parent>
        <Tab to="/healthCheck/pms">PMS</Tab>
        <Tab to="/healthCheck/autoinvite">AutoInvite</Tab>
        <Tab to="/healthCheck/billing">Billing</Tab>
        <Tab to="/healthCheck/performance">Performance</Tab>
      </Tab.Parent>
      <HealthCheckFilters
        state={filterState}
        dispatch={filterDispatch}
        allhotelGroups={allhotelGroups}
        allhotelChains={allhotelChains}
        showTelcoToggle
        showLowOutreachToggle
        showLowConversionsToggle
        showDateFilter
        showSubsidiaryStatus
        showCsmFilter
      />
      <div className={styles.tableContainer}>
        {isLoading ? (
          <LoadingIndicator marginTop={100} />
        ) : (
          <Table
            widths={widths}
            handleTitleCellClick={handleTitleCellClick}
            sortIndex={sortByIndex}
            sortDirection={sortDecreasing ? 'down' : 'up'}
          >
            <AutoInviteHealthTitleRow
              showTelcoDetails={filterState.showTelcoDetails}
              sortByIndex={sortByIndex}
              sortDecreasing={sortDecreasing}
            />

            {results.length === 0 && (
              <div className={styles.noResults}>
                No matching results. Try modifiying the filters.
              </div>
            )}
            {results.map((h, i) => (
              <AutoInviteHealthRow
                {...h}
                index={i + 1}
                showTelcoDetails={filterState.showTelcoDetails}
              />
            ))}
            <TotalRow showTelcoDetails={filterState.showTelcoDetails} data={results} />
          </Table>
        )}
      </div>
    </div>
  )
}

export default HealthCheckAutoInvite
